import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.PricingMiscItem')
export class PricingMiscItem extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(Number, 'pricePerItem')
  pricePerItem?: number

  @JsonProperty(Number, 'version')
  version?: number

  @JsonProperty(Number, 'pricePerItemDelivery')
  pricePerItemDelivery?: number

  @JsonProperty(Number, 'pricePerItemInstall')
  pricePerItemInstall?: number

  @JsonProperty(Number, 'pricePerLinFT')
  pricePerLinFT?: number

  @JsonProperty(Number, 'pricePerSQFT')
  pricePerSQFT?: number

  @JsonProperty(String, 'unit')
  unit?: string
}

